import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
import Tobi from '../../components/assets/Tobi.png';
import musa from '../../components/assets/musa.png';

const testimonials = [
  {
    name: 'Oluwaseun Adebayo',
    role: 'CEO, Global Foods Export Ltd',
    image: Tobi,
    testimony: 'The Zero2Export program transformed my understanding of international trade. Within 3 months of completing the program, I secured my first export contract.',
    rating: 5
  },
  {
    name: 'Musa Ibrahim',
    role: 'Founder, Sahel Exports',
    image: musa,
    testimony: 'The practical knowledge and mentorship I received were invaluable. The program helped me navigate complex export challenges with confidence.',
    rating: 5
  },
  {
    name: 'Chidi Okonkwo',
    role: 'Director, African Cuisine Exports',
    image: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80',
    testimony: 'From understanding documentation to making valuable connections, this program exceeded my expectations. Now exporting to three continents.',
    rating: 5
  }
];

const Zero2ExportTestimonies = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-3xl font-bold text-gray-900 sm:text-4xl"
          >
            Success Stories
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="mt-4 text-xl text-gray-600"
          >
            Hear from our alumni who are now successful exporters
          </motion.p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
              className="bg-white rounded-xl shadow-lg overflow-hidden"
            >
              <div className="p-8">
                <div className="flex items-center mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star
                      key={i}
                      className="h-5 w-5 text-yellow-400 fill-current"
                    />
                  ))}
                </div>

                <Quote className="h-8 w-8 text-blue-600 mb-4" />

                <p className="text-gray-600 mb-6">
                  "{testimonial.testimony}"
                </p>

                <div className="flex items-center">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="h-12 w-12 rounded-full object-cover"
                  />
                  <div className="ml-4">
                    <h4 className="text-lg font-semibold text-gray-900">
                      {testimonial.name}
                    </h4>
                    <p className="text-gray-600">{testimonial.role}</p>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Zero2ExportTestimonies;